import WebsiteNavbar from "../components/WebsiteNavbar";
import Footer from "../components/Footer";
import "../style/aboutUs.css";
import fastdelivery from "../images/fastdelivery.png";
import delivery from "../images/delivery.jpeg"
import invoice from "../images/invoice.png";
import responsibledisposal from "../images/responsibledisposal.png";
const stats = [
  { value: "5,000+", label: "Bins Delivered" },
  { value: "2,000+", label: "Happy Customers" },
  { value: "24/7", label: "Support Available" },
  { value: "7th", label: "Bin Free Reward" },
];

const values = [
  { icon: "ti-shield-check", label: "Reliability" },
  { icon: "ti-heart-handshake", label: "Integrity" },
  { icon: "ti-leaf", label: "Sustainability" },
  { icon: "ti-users", label: "Customer First" },
];

const checks = [
  "Locally owned and operated",
  "Reliable and on-time service",
  "Affordable & transparent pricing",
  "Environmentally responsible",
];

const reasons = [
  {
    icon: "ti-clock",
    title: "On-Time, Every Time",
    text: "We guarantee on-time delivery within your selected window. If we arrive late, your next hire is on us.",
    img: fastdelivery,
  },
  {
    icon: "ti-receipt",
    title: "No Hidden Fees",
    text: "We provide clear, upfront pricing with no hidden fees, ensuring complete transparency from booking to collection.",
    img: invoice,
  },
  {
    icon: "ti-recycle",
    title: "Responsible Disposal",
    text: "We responsibly sort and recycle waste wherever possible, helping reduce landfill and protect the environment.",
    img: responsibledisposal,
  },
  {
    icon: "ti-gift",
    title: "Loyalty Rewards",
    text: "Book six skip bins and enjoy your seventh hire free for an entire week.",
    img: fastdelivery,
  },
];

const About = () => (
  <>
    <WebsiteNavbar />

    <div className="about-page">
      {/* ── Top: title + truck ── */}
      <div className="about-top">
        <div className="about-top-text">
          <h1 className="about-title">About Jerry's Bins</h1>
          <p className="about-intro">
            Proudly serving homes, businesses and builders with reliable skip
            bin hire services.
          </p>
          <p className="about-body">
            With years of experience in waste management, we make it easy to
            keep your site clean with fast delivery, great prices and
            responsible disposal.
          </p>
          <ul className="about-checks">
            {checks.map((c) => (
              <li key={c} className="about-check-item">
                <span className="about-check-icon">
                  <i className="ti ti-check" />
                </span>
                {c}
              </li>
            ))}
          </ul>
        </div>

        <div className="about-top-img">
          <img
            src={delivery}
            alt="Jerry's Bins truck"
            className="about-truck-img"
            onError={(e) => {
              e.target.style.display = "none";
              e.target.nextSibling.style.display = "flex";
            }}
            onLoad={(e) => {
              e.target.nextSibling.style.display = "none";
            }}
          />
          <div className="about-truck-placeholder">
            <i className="ti ti-truck-delivery" />
            <p>Add truck image</p>
            <code>/truck.jpeg</code>
          </div>
        </div>
      </div>

      {/* ── Stats ── */}
      <div className="about-stats">
        {stats.map((s) => (
          <div key={s.label} className="about-stat">
            <span className="about-stat-value">{s.value}</span>
            <span className="about-stat-label">{s.label}</span>
          </div>
        ))}
      </div>

      {/* ── Mission + Values ── */}
      <div className="about-mid">
        <div className="about-mission-card">
          <p className="about-mission-label">Our Mission</p>
          <p className="about-mission-text">
            To provide simple, reliable and affordable waste solutions while
            protecting the environment for future generations.
          </p>
          <div className="about-mission-divider" />
          <p className="about-promise-label">Our Promise</p>
          <p className="about-promise-text">
            We guarantee timely delivery on every booking. If we are late, your next hire is on us.
          </p>
        </div>

        <div className="about-values-block">
          <p className="about-values-label">Our Values</p>
          <div className="about-values-grid">
            {values.map((v) => (
              <div key={v.label} className="about-value-card">
                <div className="about-value-icon">
                  <i className={`ti ${v.icon}`} />
                </div>
                <p className="about-value-label">{v.label}</p>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* ── Why Choose Us ── */}
      <div className="about-why-section">
        <div className="about-why-header">
          <h2 className="about-section-title">Why Choose Jerry's Bins?</h2>
        </div>
      </div>

      {/* ── Reasons / Quick Wins ── */}
      <div className="about-reasons">
        {reasons.map((r) => (
          <div key={r.title} className="about-reason-card">
            <div className="about-reason-card-img">
              <img
                src={r.img}
                alt={r.title}
                onError={(e) => {
                  e.target.style.display = "none";
                }}
                onLoad={(e) => {
                  e.target.nextSibling.style.display = "none";
                }}
              />
              <div className="about-reason-img-placeholder">
                <i className={`ti ${r.icon}`} />
              </div>
            </div>
            <div className="about-reason-icon">
              <i className={`ti ${r.icon}`} />
            </div>
            <h3 className="about-reason-title">{r.title}</h3>
            <p className="about-reason-text">{r.text}</p>
          </div>
        ))}
      </div>
    </div>

    <Footer />
  </>
);

export default About;
